import { render, staticRenderFns } from "./RoadmapSection.vue?vue&type=template&id=365aaf40&scoped=true"
import script from "./RoadmapSection.vue?vue&type=script&lang=js"
export * from "./RoadmapSection.vue?vue&type=script&lang=js"
import style0 from "./RoadmapSection.vue?vue&type=style&index=0&id=365aaf40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365aaf40",
  null
  
)

export default component.exports